import { useTranslation } from "react-i18next"
import { useTeams } from "@/hooks/useTeams"
import { peopleURL } from "@/utils"
import { TeamFilter } from "../../controls"
import { icons } from "../icons"
import { TagBox } from "./TagBox"

export function TeamTag({ id }: { id: string }) {
  const { t } = useTranslation()
  const { findTeam } = useTeams()
  const team = findTeam(id)

  return (
    <TagBox
      tooltip={team?.description || t("Team")}
      leftSection={<icons.Team size={16} />}
      href={`${peopleURL}?${TeamFilter.filterName}=${id}`}
    >
      {team?.name}
    </TagBox>
  )
}
